module.exports = __webpack_public_path__ + "static/media/2.0d414df7.png";